import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-no-content",
  templateUrl: "./no-content.component.html",
  styleUrls: ["./no-content.component.scss"],
})
export class NoContentComponent implements OnInit {
  @Input() title: string = "No Data"
  @Input() icon: string;
  @Input() class: string = "max-width-540 mx-auto ";
  @Input() innerClassList: string = "p-5 ";
  @Input() titleClassList: string = "mt-4 ";
  @Input() containerClassList: string = "my-3 w-100";
  @Input() slug: string = "clear_all";
  @Output() onClickNoContent = new EventEmitter()


  constructor(
    // private moduleMenuService:ModuleMenuService,
  ) {}

  ngOnInit() {
    if(!this.icon) this.icon = "application"
    if(!this.title) this.title = "No Data";
  }

  protected readonly undefined = undefined;
}
